export default "__VITE_ASSET__DF2UZxfN__"